module.exports = __webpack_public_path__ + "img/about-6.540cc247.png";